// extracted by mini-css-extract-plugin
module.exports = {"feedItem":"feedItem--3gBdC","feedImage":"feedImage--2dZ9i","feedContent":"feedContent--3jvH0"};